export default __webpack_public_path__ + "static/media/DSC_7716.2715e621.jpg";